export class ApplicationConstants {
    static ascendingOrder = 'asc';
    static descendingOrder = 'desc';
    //static baseApiUrl = 'http://localhost:8080';
    //static baseAppUrl = 'http://geocat1.geostart.local';
    //static baseAppUrl = 'http://localhost';
    static baseAppUrl = '';
    static baseCollaborationUrl = 'https://www.instamaps.cat';
    static baseGeolocalUrl = 'http://www.geolocal.cat';
    static getAllMapsUrl = ApplicationConstants.baseAppUrl + '/geocat/aplications/map/getAllGaleriaMaps.action?';
    static getNumGaleria = ApplicationConstants.baseAppUrl + '/geocat/aplications/map/getNumGaleria.action?tipusApp=1';
    static getAllPublicsMaps = ApplicationConstants.baseAppUrl + '/geocat/aplications/map/getAllPublicsMaps.action?';
    static googleKey = "AIzaSyDUUud-qayDcS4jmAUpr2PPjxHxu_qVbk0";
    static staticURL = ApplicationConstants.baseAppUrl + '/static';
    //static getHomePreviewMapsUrl = ApplicationConstants.baseApiUrl + '/homePreviewItems';
    //static getHomePreviewMapsUrl = ApplicationConstants.baseAppUrl + "/geocat/aplications/map/getAllGaleriaMaps.action?tipusApp=1&limit=4";
    static getHomePreviewMapsUrl = ApplicationConstants.baseAppUrl + "/geocat/aplications/map/getAllGaleriaMaps.action?tipusApp=1&limit=4";
    static postNewsletterSubscriptionUrl = ApplicationConstants.baseApiUrl + '/subscribe';
    static defaultLanguageCode = 'ca';
    static postLoginUrl = "/geocat/login.action?";
    static postLoginTokenUrl = "/geocat/loginToken.action?token=";
    static postLogoutUrl = "/geocat/logout.action?";
    static postRegistreUrl = "/geocat/registreUserIcgc.action?";
    static socialAuth = "/geocat/social/auth.action?";
    static eacatUrl = "https://idp.eacat.net/Logon.aspx?providerID=IDEC";
    static validateUsernameUrl = "/geocat/validateUidIcgc?";
    static validateEmailUrl = "/geocat/validateEmailIcgc?";
    static postRememberUrl = "/geocat/user/reminderMail.action?";
    static postRenovarUrl = "/geocat/user/renewPassword.action?";
    static getAllMapsByUserUrl = "/geocat/aplications/map/getAllMapsByUser.action?";
    static getUserSimpleUrl = "/geocat/user/getUserSimple.action?";
    static newMapUrl = ApplicationConstants.baseAppUrl + "/mapa.html?";
    static visorUrl = ApplicationConstants.baseAppUrl + "/visor.html?";
    static delteMapUrl = "/geocat/aplications/map/deleteMap.action?";
    static updatePasswordUrl = "/geocat/user/updatePasswordIcgc.action?";
    static duplicateMapUrl = "/geocat/aplications/map/duplicateMap.action?";    
    static urlShortenerUrl = "https://www.googleapis.com/urlshortener/v1/url?key="+ApplicationConstants.googleKey;
    static sendMailUrl = "/geocat/mail/sendMail.action?";
    static getConvidatsUrl = "/geocat/aplications/map/getConvidatsByBusinessId.action?";
    static deleteConvidatUrl = "/geocat/aplications/map/deleteConvidatByBusinessId.action?";
    static deleteConvidatByUid = "/geocat/aplications/map/deleteConvidatByBusinessIdAndUid.action?";
    static changeVisibilityMapUrl = "/geocat/aplications/map/updateVisibility.action?";
    static fallbackImageUrl = ApplicationConstants.staticURL+'/img/instamapes_icon_color.jpg';
    static baseImageUrl = '/galeria/';
    static baseEditorUrl = '/mapa.html';
    static userGalleryUrl = '/#/gallery?user=';
    static searchGaleriaMapsByUser = '/geocat/aplications/map/searchGaleriaMapsByUser.action?page=0&tipusApp=1&user=';
	static searchGaleriaMaps = '/geocat/aplications/map/searchGaleriaMaps.action?page=0&tipusApp=1&q=';
    static searchGaleriaApps = '/geocat/aplications/map/searchGaleriaMaps.action?page=0&q=';
    static getConfiguradesUser = ApplicationConstants.baseGeolocalUrl + '/PRG/eines/getConfiguradesUser.action?';
    static proxy_betterWMS = ApplicationConstants.baseAppUrl + "/maps/proxy_betterWMS.cgi?";
    static migrateMap = "/geocat/aplications/map/migrateMap.action?";
    static createUsersFromMap = "geocat/aplications/map/createUsersFromMap.action?";
    static getAllMapsDerivatsByUser = "/geocat/aplications/map/getAllMapsDerivatsByUser.action?";
    static countMapsDerivatsByUser = "/geocat/aplications/map/countMapesDerivats.action?";
    static countMapsHeretatsByUser = "/geocat/aplications/map/countMapesHeretats.action?";
    static getAllMapsHeretatsByUser= "/geocat/aplications/map/getAllMapsHeretatsByUser.action?";
    static deleteUserByUid = "/geocat/admin/deleteUser.action?";
    static paramAplications = {
        'pcivil': {
            "nom": "Protecció civil",
            "description": "Gestiona la informació relativa a Protecció civil per augmentar la seguretat dels ciutadans. Identifica els punts d'actuació prioritària en cas d'una emergència.",
            "img": "/static/img/thumb_ed_pcivil.png",
            "url": "https://pcivil.icgc.cat/editorpapspcivil/index.html?codiUsuari="
        },
        'infoparcela': {
            "nom": "InfoParcela",
            "description": "Permet realitzar un document amb informació referent a la parcel·la.",
            "img": "/static/img/thumb_ed_infoparcela.png",
            "url": ApplicationConstants.baseGeolocalUrl+"/PRG/aplicacions/infoparcela.action?fallback=infoparcela&codiUsuari=",
            "eliminar": ApplicationConstants.baseGeolocalUrl+"/PRG/aplicacions/infoparcela/eliminar_geolocal.action?",
            "editor": ApplicationConstants.baseGeolocalUrl+"/PRG/aplicacions/infoparcela/modificar.action?businessId="
        },
        'peolics': {
            "nom": "Editor de Parcs Eòlics",
            "description": "Actualitza la informació dels parcs eòlics. Col·labora mantenint la informació.",
            "img": "/static/img/thumb_ed_peolics.png",
            "url": ApplicationConstants.baseGeolocalUrl+"/geoLocal/crearAplicacionEditorParcsEolics.jsp?codiUsuari="
        },
        'carrerer': {
            "nom": "Gestor de canvis carrerer",
            "description": "Gestiona els canvis del carrerer. Ajuda a mantenir la base de carrers de l'ICGC.",
            "img": "/static/img/thumb_ed_carrerer.png",
            "url": ApplicationConstants.baseGeolocalUrl+"/EdCarrerer/editorCarrerer.action?codiUsuari="
        },
        'incasol': {
            "nom": "Visors INCASÒL",
            "description": "Ja pots tenir un visor de mapes a la teva web!. Crea els teus propis visors personalitzats i afegeix-hi la teva cartografia.",
            "img": "/static/img/thumb_ed_incasol.png",
            "url": ApplicationConstants.baseGeolocalUrl+"/PRG/aplicacions/incasol.action?",
            "editor": ApplicationConstants.baseGeolocalUrl+"/PRG/aplicacions/incasol/modificar.action?businessId=",
            "eliminar": ApplicationConstants.baseGeolocalUrl+"/PRG/aplicacions/incasol/eliminar_geolocal.action?"
        },
        'atles': {
            "eliminar": ApplicationConstants.baseGeolocalUrl+"/PRG/aplicacions/atles/eliminar_geolocal.action?"
        }
    };
    static perfilConfig = {
        "0": [ApplicationConstants.paramAplications.pcivil, ApplicationConstants.paramAplications.infoparcela, ApplicationConstants.paramAplications.peolics, ApplicationConstants.paramAplications.carrerer, ApplicationConstants.paramAplications.incasol],
        "1": [],
        "2": [ApplicationConstants.paramAplications.pcivil, ApplicationConstants.paramAplications.infoparcela],
        "3": [ApplicationConstants.paramAplications.pcivil],
        "4": [],
        "5": [],
        "6": [],
        "7": [ApplicationConstants.paramAplications.peolics],
        "8": [ApplicationConstants.paramAplications.incasol],
        "9": [ApplicationConstants.paramAplications.pcivil]
    };
}



// WEBPACK FOOTER //
// ./src/shared/applicationConstants.js